export const routes = {
  digitalInvoice: (company: string) => `/${company}/digital-invoice`,
  contactValidation: (company: string) => `/${company}/contact-validation`,
  couponRequest: (company: string) => `/${company}/coupon-request`,
};
